// useAnalytics.ts
import { useMemo } from "react";
import { useUser } from "../../services/user-context";
import { getTenantId } from "../../services/utils";
import { initializePostHog } from "./init";

type DynamicProps = Record<string, any>;

export function useAnalytics() {
  const { userInfo } = useUser() as { userInfo: { email: string } };
  const posthog = initializePostHog();

  function captureEvent(eventName: string, dynamicProps: DynamicProps = {}): void {
    const payload = {
      ...dynamicProps,
      tenant_id: getTenantId(),
      user_email: userInfo?.email,
      user_agent: navigator.userAgent,
      timestamp: new Date().toISOString(),
    };
    posthog.capture(eventName, payload);
  }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  return useMemo(() => ({ captureEvent }), [userInfo?.email]);
}
